/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StepRecipeModalUpdateMutationVariables = {|
  id: string,
  description?: ?string,
  time?: ?any,
  speed?: ?number,
  temperatureDegrees?: ?number,
  temperatureControl?: ?number,
  turbo?: ?boolean,
  waitingInstructions?: ?string,
  warning?: ?string,
  isRobot?: ?boolean,
  ingredient?: ?string,
  weight?: ?string,
  unit?: ?string,
|};
export type StepRecipeModalUpdateMutationResponse = {|
  +recipeStepUpdate: ?{|
    +recipeStep: ?{|
      +id: string,
      +description: string,
      +media: ?string,
    |}
  |}
|};
export type StepRecipeModalUpdateMutation = {|
  variables: StepRecipeModalUpdateMutationVariables,
  response: StepRecipeModalUpdateMutationResponse,
|};
*/


/*
mutation StepRecipeModalUpdateMutation(
  $id: ID!
  $description: String
  $time: Time
  $speed: Int
  $temperatureDegrees: Int
  $temperatureControl: Int
  $turbo: Boolean
  $waitingInstructions: String
  $warning: ID
  $isRobot: Boolean
  $ingredient: ID
  $weight: String
  $unit: String
) {
  recipeStepUpdate(input: {id: $id, description: $description, time: $time, speed: $speed, temperatureDegrees: $temperatureDegrees, temperatureControl: $temperatureControl, turbo: $turbo, waitingInstructions: $waitingInstructions, warning: $warning, isRobot: $isRobot, ingredient: $ingredient, weight: $weight, unit: $unit}) {
    recipeStep {
      id
      description
      media
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "description",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "time",
    "type": "Time"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "speed",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "temperatureDegrees",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "temperatureControl",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "turbo",
    "type": "Boolean"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "waitingInstructions",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "warning",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isRobot",
    "type": "Boolean"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ingredient",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "weight",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "unit",
    "type": "String"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "description",
            "variableName": "description"
          },
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "ingredient",
            "variableName": "ingredient"
          },
          {
            "kind": "Variable",
            "name": "isRobot",
            "variableName": "isRobot"
          },
          {
            "kind": "Variable",
            "name": "speed",
            "variableName": "speed"
          },
          {
            "kind": "Variable",
            "name": "temperatureControl",
            "variableName": "temperatureControl"
          },
          {
            "kind": "Variable",
            "name": "temperatureDegrees",
            "variableName": "temperatureDegrees"
          },
          {
            "kind": "Variable",
            "name": "time",
            "variableName": "time"
          },
          {
            "kind": "Variable",
            "name": "turbo",
            "variableName": "turbo"
          },
          {
            "kind": "Variable",
            "name": "unit",
            "variableName": "unit"
          },
          {
            "kind": "Variable",
            "name": "waitingInstructions",
            "variableName": "waitingInstructions"
          },
          {
            "kind": "Variable",
            "name": "warning",
            "variableName": "warning"
          },
          {
            "kind": "Variable",
            "name": "weight",
            "variableName": "weight"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeStepUpdatePayload",
    "kind": "LinkedField",
    "name": "recipeStepUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeStepNode",
        "kind": "LinkedField",
        "name": "recipeStep",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "media",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StepRecipeModalUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StepRecipeModalUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "StepRecipeModalUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation StepRecipeModalUpdateMutation(\n  $id: ID!\n  $description: String\n  $time: Time\n  $speed: Int\n  $temperatureDegrees: Int\n  $temperatureControl: Int\n  $turbo: Boolean\n  $waitingInstructions: String\n  $warning: ID\n  $isRobot: Boolean\n  $ingredient: ID\n  $weight: String\n  $unit: String\n) {\n  recipeStepUpdate(input: {id: $id, description: $description, time: $time, speed: $speed, temperatureDegrees: $temperatureDegrees, temperatureControl: $temperatureControl, turbo: $turbo, waitingInstructions: $waitingInstructions, warning: $warning, isRobot: $isRobot, ingredient: $ingredient, weight: $weight, unit: $unit}) {\n    recipeStep {\n      id\n      description\n      media\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2aeaec86a17ed0e989ba41db08a2be1b';

module.exports = node;
